export default __webpack_public_path__ + "26f053f91480ab77bb03bf274640324d.png";